import { render, staticRenderFns } from "./groupScroller.vue?vue&type=template&id=f52936dc&"
import script from "./groupScroller.vue?vue&type=script&lang=ts&"
export * from "./groupScroller.vue?vue&type=script&lang=ts&"
import style0 from "./groupScroller.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports